<template>
  <div class="mt-4 mb-2">
    <div class="row">
      <div class="col-lg-6 col-12">
        <div class="row">
          <div class="col-lg-6 col-12 input-wrapper input-sm-margin" :class="{error: errors.has(`experience.duration.${id}.to`) || errors.has(`experience.duration.${id}.from`)}">
            <div class="form-label">
              FROM - TO (MM/YY)
              <template v-if="required">*</template>
            </div>
            <div class="row">
              <div class="col-5">
                <datepicker :disabled-dates="disabledDatesStart" input-class="text-center" @input="date => formatDateOn('duration.from', 'MM.YYYY')(date)" :language="lang" minimum-view="month" maximum-view="year" initial-view="year" format="MM. yyyy"></datepicker>
              </div>
              <div class="col-2 text-center">-</div>
              <div class="col-5">
                <datepicker :disabled-dates="disabledDatesEnd" :disabled="endDisabled" input-class="text-center" @input="date => formatDateOn('duration.to', 'MM.YYYY')(date)" :language="lang" minimum-view="month" maximum-view="year" initial-view="year" format="MM. yyyy"></datepicker>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <span v-if="errors.has(`experience.duration.${id}.from`)" class="error-msg">{{ errors.get(`experience.duration.${id}.from`) }}<br></span>
                <span v-if="errors.has(`experience.duration.${id}.to`)" class="error-msg">{{ errors.get(`experience.duration.${id}.to`) }}</span>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-12 input-wrapper input-sm-margin"  :class="{error: errors.has(`experience.duration.${id}.country`)}">
            <div class="form-label">
              Country
              <template v-if="required">*</template>
            </div>
            <v-select v-model="duration.country" name="duration.country" :options="countries" label="nameEn" placeholder="Select option"></v-select>
            <span v-if="errors.has(`experience.duration.${id}.country`)" class="error-msg">{{ errors.get(`experience.duration.${id}.country`) }}</span>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12">
        <div class="row">
          <v-input v-model="duration.employer" :name="`experience.duration.${id}.employer`" label="Employer" :required="required" addclass="input-sm-margin"></v-input>
          <v-input v-model="duration.position" :name="`experience.duration.${id}.position`" label="Position" :required="required" addclass="input-sm-margin"></v-input>
        </div>
      </div>
    </div>
    <div class="row">
      <v-input v-model="duration.maintask" :name="`experience.duration.${id}.maintask`" label="Main Tasks" :required="required" columnclass="col-12"></v-input>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import VInput from '../fields/VInput'
import vSelect from 'vue-select'
import Datepicker from 'vuejs-datepicker'
import { en } from 'vuejs-datepicker/dist/locale'

const data = {
  to: '',
  from: '',
  country: '',
  employer: '',
  position: '',
  maintask: ''
}

export default {
  inject: [
    'errors'
  ],
  components: {
    VInput,
    vSelect,
    Datepicker
  },
  props: {
    id: {
      type: Number,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    countries: {
      type: Array,
      required: true
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      lang: en,
      duration: { ...data }
    }
  },
  computed: {
    disabledDatesStart () {
      return {
        from: new Date()
      }
    },
    disabledDatesEnd () {
      return {
        to: this.startDate,
        from: new Date()
      }
    },
    startDate () {
      if (this.duration.from && this.duration.from.length) {
        const parts = this.duration.from.split('.')
        const year = parts[1]
        const month = parseInt(parts[0]) - 1

        return new Date(year, month, 1)
      }
      return null
    },
    endDisabled () {
      return (this.duration.from && this.duration.from.length === 0) || !this.duration.from
    }
  },
  methods: {
    formatDateOn (field, format) {
      return date => {
        const value = moment(date).format(format)
        const parts = field.split('.')
        if (parts.length === 1) {
          this[field] = value
        } else {
          this[parts[0]][parts[1]] = value
        }
      }
    }
  },
  watch: {
    duration: {
      deep: true,
      immediate: true,
      handler: function (duration) {
        this.$emit('input', duration)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .input-wrapper {
        &.error {
            input {
                border-color: #c2063b;
            }
        }

        .error-msg {
            color: #c2063b;
        }
    }
</style>
